import {isNullOrUndefined} from './utils'
import type {Maybe} from '../types'

export default function assert(value: unknown, message?: string | Error): asserts value {
  if (!value) {
    throw message instanceof Error ? message : new Error(message ?? 'Assertion failed')
  }
}

export const ok = assert

export function assertNonNil<T>(value: Maybe<T>, message = 'Expected message to be not nil'): T {
  if (isNullOrUndefined(value)) {
    throw new Error(message)
  }

  return value
}
